const baseUrlDefault = "http://tour.asiatech.ptp/";

export const GROUP_CITIES_QUERY_URL = `${
  process.env.NEXT_PUBLIC_TOUR_BASE_URL_API || baseUrlDefault
}group/text-search`;
